<div [ngClass]="{'choice-delivery-container-active': deliverySelect.isActive, 'choice-delivery-container': !deliverySelect.isActive}"
     (click)="selectRadio()">
  <div class="choice-delivery-description-container">
    <mat-radio-button
      class="custom-radio-button"
      [ngClass]="{'choice-delivery-radio-active': deliverySelect.isActive, 'choice-delivery-radio': !deliverySelect.isActive}"
      name="delivery"
      [checked]="deliverySelect.isActive"
      (change)="selectRadio()">
    </mat-radio-button>

    <div class="choice-delivery-text-container">
      <div class="choice-delivery-standard-text"
        [ngClass]="{'express-delivery': isExpress}"
      >
        <span>{{ deliverySelect.deliveryMethod | translate }}</span>
        @if (isExpress) {
          <img src="assets/svg/yandex-delivery.svg" alt="yandex delivery">
        }
      </div>
      @if (!isPickup) {
        <div class="choice-delivery-duration">{{ deliverySelect.deliveryDuration | translate }}</div>
      } @else {
        <div class="choice-delivery-duration">{{ deliverySelect.deliveryPrice | translate }}</div>
      }
      @if (!isPickup) {
        <div class="choice-delivery-price">{{ deliverySelect.deliveryPrice | translate }}</div>
      }
    </div>

  </div>
</div>
